import { NgModule } from "@angular/core";
import { DistributionDozComponent } from "@app/components/distribution/doz/distributionDoz.component";
import { LoaderModule } from "@app/components/loader/loader.module";
import { DatePipe, JsonPipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { AccordionModule } from "primeng/accordion";
import {
  MedIconAimbulanceModule, MedIconArchiveModule, MedIconArrowCircleLeftModule, MedIconArrowLeftModule,
  MedIconArrowRightModule,
  MedIconBlockModule, MedIconBugModule,
  MedIconCheckCircleFillModule,
  MedIconCheckModule, MedIconChevronRightModule,
  MedIconCircleModule, MedIconCloseModule, MedIconCopyModule,
  MedIconDeleteModule,
  MedIconDocsModule, MedIconDownloadModule, MedIconInfoModule,
  MedIconKeyLargeModule, MedIconPlusModule, MedIconQuestionModule,
  MedIconRefreshModule,
  MedIconReplyModule, MedIconSyncModule, MedIconTransactionModule,
  MedIconVisibilityModule, MedIconVisibilityOffModule, MedIconWarningModule,
} from "@mk/med-icons";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import {
  MedBtnModule,
  MedBubbleModule, MedCardModule, MedCheckboxModule, MedDatepickerModule,
  MedInputModule,
  MedModalModule, MedMultiSelectModule, MedRadioGroupModule, MedSelectModule, MedTabGroupModule,
  MedTextareaModule,
  MedUploadFileModule,
} from "@mk/med-ui";
import { FormsModule } from "@angular/forms";
import { BasketDozComponent } from "@app/components/distribution/doz/basket/basket.doz.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import {
  SubDistributionDozComponent,
} from "@app/components/distribution/doz/subDistribution/subDistributionDoz.component";
import { TooltipModule } from "primeng/tooltip";
import { MedSignModule } from "@mk/med-sign";
import { DialogModule } from "primeng/dialog";
import { ScrollPanelModule } from "primeng/scrollpanel";
import {
  ViewDistributionModalComponent,
} from "@app/components/distribution/view/view-distribution-modal/view-distribution-modal.component";
import { AvatarModule } from "primeng/avatar";
import { MultiSelectModule } from "primeng/multiselect";
import {SeriesDozComponent} from "@app/components/distribution/doz/seriesDoz/seriesDoz.component";
@NgModule({
  declarations: [
    DistributionDozComponent,
    BasketDozComponent,
    SubDistributionDozComponent,
    SeriesDozComponent
  ],
  imports: [
    LoaderModule,
    NgIf,
    AccordionModule,
    DatePipe,
    MedIconAimbulanceModule,
    MedIconCheckCircleFillModule,
    MedIconCircleModule,
    MedIconDeleteModule,
    MedIconDocsModule,
    SharedModule,
    TableModule,
    MedIconKeyLargeModule,
    MedBubbleModule,
    MedIconRefreshModule,
    MedBtnModule,
    MedIconReplyModule,
    MedIconArrowRightModule,
    AvatarModule,
    MultiSelectModule,
    MedIconCheckModule,
    MedIconBlockModule,
    MedIconVisibilityModule,
    MedIconVisibilityOffModule,
    MedInputModule,
    FormsModule,
    NgStyle,
    MedIconDownloadModule,
    MedModalModule,
    MedUploadFileModule,
    MedTextareaModule,
    MedCardModule,
    MedDatepickerModule,
    MedIconCloseModule,
    MedRadioGroupModule,
    MedIconPlusModule,
    MedMultiSelectModule,
    MedSelectModule,
    MedCheckboxModule,
    PageTitleModule,
    MedIconArchiveModule,
    MedIconChevronRightModule,
    NgForOf,
    MedIconCopyModule,
    TooltipModule,
    MedSignModule,
    MedIconBugModule,
    MedIconSyncModule,
    ScrollPanelModule,
    MedIconArrowLeftModule,
    MedIconArrowCircleLeftModule,
    NgClass,
    MedIconWarningModule,
    MedIconQuestionModule,
    MedIconTransactionModule,
    DialogModule,
    ViewDistributionModalComponent,
    JsonPipe,
    MedIconInfoModule,
    MedTabGroupModule,
  ],
  exports: [],
})
export class DistributionDozModule {}
